import { render } from "./BtnGroupXMobile.vue?vue&type=template&id=4198e770&scoped=true"
import script from "./BtnGroupXMobile.vue?vue&type=script&lang=js"
export * from "./BtnGroupXMobile.vue?vue&type=script&lang=js"

import "./BtnGroupXMobile.vue?vue&type=style&index=0&id=4198e770&scoped=true&lang=css"

import exportComponent from "/home/dr/PhpstormProjects/anh/vue/scheduleweek/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4198e770"]])

export default __exports__